import { useEffect } from "react";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import { Outlet, useLocation } from "react-router-dom";
import { PublicThemeProvider } from "../context/PublicThemeContext";
import { LanguageProvider, useLanguage } from "../context/LanguageContext";
import { pub } from "../lib/pubThemeClasses";
import { PublicToaster } from "./ui/sonner";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppButton from "./WhatsAppButton";
import { initTracking, trackPageView } from "../lib/tracking";

function SkipLink() {
  const { t } = useLanguage();
  return (
    <a href="#main-content" className="skip-link">{t("layout.skipToContent")}</a>
  );
}

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => { initTracking(); }, []);
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); trackPageView(pathname); }, [pathname]);

  return (
    <PublicThemeProvider>
      <LanguageProvider>
        <div className={`relative min-h-screen min-w-0 overflow-x-hidden bg-site transition-colors duration-300 ${pub.pageText} selection:bg-[#FF4F00] selection:text-neutral-950`}>
          <SkipLink />
          <Header />
          <main id="main-content" tabIndex={-1} className="pt-16 md:pt-[7.25rem] outline-none">
            <Outlet />
          </main>
          <Footer />
          <WhatsAppButton />
          <PublicToaster />
          <Analytics />
          <SpeedInsights />
        </div>
      </LanguageProvider>
    </PublicThemeProvider>
  );
}
